import axios from 'axios';
import config from '../config';

axios.defaults.withCredentials = true;

export const verifyEmail = async (uid, token) => {
    try {
        const verifyEmailResponse = await axios.post(config.backend_url+`/verify/${uid}/${token}`);
        return verifyEmailResponse.data;
    } catch (error) {
        return error.response.data;
    }
}

export const sendVerificationEmail = async (uid) => {
    try {
        const sendVerificationEmailResponse = await axios.post(config.backend_url+`/sendVerificationEmail/${uid}`);
        return sendVerificationEmailResponse.data;
    } catch (error) {
        return error.response.data;
    }
}

export const isAuthenticate = async () => {
    try {
        const isAuthenticateResponse = await axios.get(`${config.backend_url}/isAuth`);
        return isAuthenticateResponse.data;
    } catch (error) {
        return error.response.data;
    }
}

export const forgotPasswordRequest = async (email) => {
    try {
        const sendForgotPasswordEmailResponse = await axios.post(`${config.backend_url}/reset/forgot-password`, {
            email
        });
        return sendForgotPasswordEmailResponse.data;
    } catch (error) {
        return error.response.data;
    }
}
export const resetPassword = async (uid, token, password) => {
    try {
        const sendForgotPasswordEmailResponse = await axios.post(`${config.backend_url}/reset-password/${uid}/${token}`, {
            password
        });
        return sendForgotPasswordEmailResponse.data;
    } catch (error) {
        return error.response.data;
    }
}

export const updateUserConsent = async (uid, payload) => {
    try {
        const updateUserConsentResp = await axios.post(`${config.backend_url}/setting/${uid}`, payload);
        return updateUserConsentResp.data;
    } catch (error) {
        return error.response.data;
    }
}

export const terminatedUser = async (uid) => {
    try {
        const terminatedUserResp = await axios.get(`${config.backend_url}/setting/terminatedUser/${uid}`);
        return terminatedUserResp.data;
    } catch (error) {
        return error.response.data;
    }
}

export const sendNotificationInfo = async (payload) => {
    try {
        const sendNotificationInfoResp = await axios.post(`${config.backend_url}/notification/create`, payload);
        return sendNotificationInfoResp.data;
    } catch (error) {
        return error.response.data;
    }
}

export const logEvent = async (payload = {}) => {
    try {
        const logEventResp = await axios.post(`${config.backend_url}/log/create`, payload);
        return logEventResp.data;
    } catch (error) {
        return error.response.data;
    }
}

export const logOpenEvent = async (payload = {}) => {
    try {
        const logEventResp = await axios.post(`${config.backend_url}/log/open/create`, payload);
        return logEventResp.data;
    } catch (error) {
        return error.response.data;
    }
}

export const getCovidTestResult = async (formData) => {
    try {
        const res = await axios.post(config.backend_url + '/uploadWithVerifyV2', formData)
        return res.data;
    } catch (error) {
        return error.response?.data ?? null;
    }
}
export const getCovidTestResultFetch = async (formData) => {
    try {

        const response = await fetch(config.backend_url + '/uploadWithVerifyV2', {
            credentials: "include",
            method: "POST",
            body: formData
        })
        return response.json();
    } catch (error) {
        return error.response?.data ?? null;
    }
}

export const setParallelTestResult = async (formData) => {
    try {
        const res = await axios.post(config.backend_url + '/parallelVerifyV2', formData)
        return res.data;
    } catch (error) {
        return error.response?.data ?? null;
    }
}

export const getUserDetail = async () => {
    try {
        const getUserDetailResp = await axios.get(`${config.backend_url}/userdetails`);
        return getUserDetailResp.data;
    } catch (error) {
        return error.response.data;
    }
}

export const getAlerts = async (size = 10, page = 1, uid) => {
    try {
        const getAlertsResp = await axios.get(`${config.backend_url}/alert/page?size=${size}&page=${page}&uid=${uid}`);
        return getAlertsResp.data;
    } catch (error) {
        return error.response.data;
    }
}

export const getAlertById = async (alertId) => {
    try {
        const getAlertsResp = await axios.get(`${config.backend_url}/alert/${alertId}`);
        return getAlertsResp.data;
    } catch (error) {
        return error.response.data;
    }
}

export const getCovidHistory = async (from, to) => {
    try {
        const res = await axios.get(`${config.backend_url}/testresults/covidtests/${from}/${to}`);
        return res.data;
    } catch (error) {
        return error.response?.data;
    }
}

export const initCovidHistory = async () => {
    try {
        const res = await axios.get(`${config.backend_url}/testresults/initializeHistory`);
        return res.data;
    } catch (error) {
        return error.response?.data;
    }
}

export const getCardioHistory = async (from, to) => {
    try {
        const res = await axios.get(`${config.backend_url}/testresults/cardiotests/${from}/${to}`);
        return res.data;
    } catch (error) {
        return error.response?.data;
    }
}

export const getHR = async (payload) => {
    try {
        const res = await axios.post(`${config.backend_url}/getHR`, payload);
        return res.data;
    } catch (error) {
        return error.response?.data;
    }
}

export const saveCardioTestResult = async (payload) => {
    try {
        const res = await axios.post(`${config.backend_url}/testresults`, payload);
        return res.data;
    } catch (error) {
        return error.response?.data;
    }
}

export const getBpCalibration = async (payload) => {
  try {
      const res = await axios.post(`${config.backend_url}/getBpCalibration`, payload);
      return res.data;
  } catch (error) {
      return error.response?.data;
  }
}

export const getBpAndSpO2Calibration = async (payload) => {
  try {
      const res = await axios.post(`${config.backend_url}/getBpAndSpO2Calibration`, payload);
      return res.data;
  } catch (error) {
      return error.response?.data;
  }
}

export const fetchCardioResults = async (payload) => {
  try {
      const res = await axios.post(`${config.backend_url}/fetchCardioResults`, payload);
      return res.data;
  } catch (error) {
      return error.response?.data;
  }
}

export const fetchCardioResultsV2 = async (payload) => {
  try {
      const res = await axios.post(`${config.backend_url}/fetchCardioResults/v2`, payload);
      return res.data;
  } catch (error) {
      return error.response?.data;
  }
}

export const fetchFirstCardioPOCResults = async (payload) => {
  try {
      const res = await axios.post(`${config.backend_url}/fetchCardioResults/poc/getBpCalibration`, payload);
      return res.data;
  } catch (error) {
      return error.response?.data;
  }
}

export const fetchFinalCardioPOCResults = async (payload) => {
  try {
      const res = await axios.post(`${config.backend_url}/fetchCardioResults/poc/getBpAndSpO2Calibration`, payload);
      return res.data;
  } catch (error) {
      return error.response?.data;
  }
}


export const getCovidResultsByUser = async (from, to, uid) => {
    try {
        const res = await axios.get(`${config.backend_url}/testresults/covidtests/${from}/${to}/${uid}`);
        return res.data;
    } catch (error) {
        return error.response?.data;
    }
}

export const getCadioResultsByUser = async (from, to, uid) => {
    try {
        const res = await axios.get(`${config.backend_url}/testresults/cardiotests/${from}/${to}/${uid}`);
        return res.data;
    } catch (error) {
        return error.response?.data;
    }
}

export const getUserStatus = async (data) => {
  try {
      const res = await axios.post(`${config.backend_url}/userdetails/userStatus`, data);
      return res.data;
  } catch (error) {
      return error.response?.data;
  }
}

export const getUserStatusV2 = async (data) => {
  try {
      const res = await axios.post(`${config.backend_url}/userdetails/userStatus/v2`, data);
      return res.data;
  } catch (error) {
      return error.response?.data;
  }
}


export const getCovidTestImagesById = async (tid) => {
    try {
        const res = await axios.get(`${config.backend_url}/testresults/covid/${tid}`);
        return res.data;
    } catch (error) {
        return error.response?.data;
    }
}

export const getStripeCustomerById = async (stripeCustomerId) => {
    try {
        const res = await axios.get(`${config.backend_url}/billing/stripe/customer/${stripeCustomerId}`);
        return res.data;
    } catch (error) {
        return error.response?.data;
    }
}

export const getCustomerByUid = async (uid) => {
  try {
    const res = await axios.get(`${config.backend_url}/customer/${uid}`);
    return res.data;
  } catch (error) {
    return error.response?.data;
  }
};

export const createStripeCustomer = async (payload) => {
  try {
    const res = await axios.post(`${config.backend_url}/billing/stripe/customer/`, { ...payload });
    return res.data;
  } catch (error) {
    return error.response?.data;
  }
};
export const getStripeCustomer = async (customerId) => {
  try {
    const res = await axios.get(`${config.backend_url}/billing/stripe/customer/${customerId}`);
    return res.data;
  } catch (error) {
    return error.response?.data;
  }
};
export const updateStripeSubscription = async (payload) => {
  try {
    const res = await axios.patch(`${config.backend_url}/billing/stripe/subscription/`, { ...payload });
    return res.data;
  } catch (error) {
    console.log(error)
    return error.response?.data;
  }
};
export const cancelSubscription = async ({uid, subscription}) => {
  try {
    const res = await axios.post(`${config.backend_url}/billing/stripe/subscription/cancel`, { uid, subscription });
    return res.data;
  } catch (error) {
    console.log(error)
    return error.response?.data;
  }
};
export const createStripeSubscription = async (payload) => {
  try {
    const res = await axios.post(`${config.backend_url}/billing/stripe/subscription/`, { ...payload });
    return res.data;
  } catch (error) {
    return error.response?.data;
  }
};
export const getStripeSubscription = async (subscriptionId) => {
  try {
    const res = await axios.get(`${config.backend_url}/billing/stripe/subscription/${subscriptionId}`);
    return res.data;
  } catch (error) {
    return error.response?.data;
  }
};
export const getStripeProduct = async (productId) => {
  try {
    const res = await axios.get(`${config.backend_url}/billing/stripe/product/${productId}`);
    return res.data;
  } catch (error) {
    return error.response?.data;
  }
};
export const getAllStripeTransactions = async () => {
  try {
    const res = await axios.get(`${config.backend_url}/billing/stripe/transactions`);
    return res.data;
  } catch (error) {
    return error.response?.data;
  }
};
export const getSubscriptionByUid = async (uid) => {
  try {
    const res = await axios.get(`${config.backend_url}/subscription/${uid}`);
    return res.data;
  } catch (error) {
    return error.response?.data;
  }
};
export const getSubscriptionsByUid = async (uid) => {
  try {
    const res = await axios.get(`${config.backend_url}/subscription/${uid}/list`);
    return res.data;
  } catch (error) {
    return error.response?.data;
  }
};
export const getPricePlan = async (planId) => {
  try {
    const res = await axios.get(`${config.backend_url}/billing/stripe/plan/${planId}`);
    return res.data;
  } catch (error) {
    return error.response?.data;
  }
};
export const getInvoiceByInvoiceId = async (invoiceId) => {
  try {
    const res = await axios.get(`${config.backend_url}/billing/stripe/invoice/${invoiceId}`);
    return res.data;
  } catch (error) {
    return error.response?.data;
  }
};
export const getPaymentIntentById = async (paymentIntentId, stripeCustomerId) => {
  try {
    const res = await axios.get(`${config.backend_url}/billing/stripe/paymentIntent/${paymentIntentId}/${stripeCustomerId}`);
    return res.data;
  } catch (error) {
    return error.response?.data;
  }
};
export const updatePaymentMethodOfStripeCustomer = async (customerId, paymentMethodId) => {
  try {
    const res = await axios.post(
      `${config.backend_url}/billing/stripe/customer/update/paymentMethod`, { customerId, paymentMethodId }
    );
    return res.data;
  } catch (error) {
    return error.response?.data;
  }
};
export const getInvoicesByCustomer = async (customerId, limit = 10, page) => {
  try {
    const res = await axios.get(
      `${config.backend_url}/billing/stripe/invoices/${customerId}?limit=${limit}&page=${page}`
    );
    return res.data;
  } catch (error) {
    return error.response?.data;
  }
};
export const getPaymentsByCustomer = async (customerId, limit = 10, page) => {
  try {
    const res = await axios.get(`${config.backend_url}/billing/stripe/payments/${customerId}?limit=${limit}&page=${page}`);
    return res.data;
  } catch (error) {
    return error.response?.data;
  }
};

export const getProductsAndPrices = async (affId) => {
  try {
    const res = await axios.get(`${config.backend_url}/product/prices/?affiliateLinkId=${affId}`);
    return res.data;
  } catch (error) {
    return error.response?.data;
  }
};

export const getAffiliateAcById = async (affiliateLinkId) => {
  try {
    const res = await axios.get(`${config.backend_url}/affiliate/link/${affiliateLinkId}`);
    return res.data;
  } catch (error) {
    return error.response?.data;
  }
};

export const getAffiliateAcByIdV2 = async (affiliateLinkId) => {
  try {
    const res = await axios.get(`${config.backend_url}/affiliate/affiliateLink/${affiliateLinkId}/v2`);
    return res.data;
  } catch (error) {
    return error.response?.data;
  }
};
export const updateSubscriptionAutoRenew = async (payload) => {
  try {
    const res = await axios.patch(`${config.backend_url}/billing/stripe/subscription/autorenew`, payload);
    return res.data;
  } catch (error) {
    return error.response?.data;
  }
};

export const validatePOCCode = async (code) => {
  try {
      const res = await axios.get(`${config.backend_url}/testresults/validatePOCCode/${code}`);
      return res.data;
  } catch (error) {
      return error.response?.data;
  }
}

export const getRevenueCatSubscriberByUid = async (uid) => {
  try {
      const res = await axios.get(`${config.backend_url}/payment/v1/subscribers/${uid}`);
      return res.data;
  } catch (error) {
      return error.response?.data;
  }
}